import moment from 'moment'

export default function formatPostDateHours(date) {
    if (!date) return null
    return moment(date, 'YYYY-MM-DD hh:mm:ss').format('hh:mm')
}